/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Map Edit Icon component.
 */
export const MapEditIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19.0466 4.55376L8.9938 21.996L5.64164 23.0803C5.63343 23.0789 5.62536 23.0757 5.61804 23.0714C5.61016 23.0668 5.60356 23.0606 5.59808 23.0535L4.86389 19.6268L14.9152 2.17174L19.0466 4.55376Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M12.3462 5.75977L17.1255 8.51909' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
    </svg>
  );
};

export default MapEditIcon;
